/**
 * @generated SignedSource<<6f1560a1e596d5aeac087b552ac1fdc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null | undefined;
  readonly status: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment";
};
export type ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "05d2a2275047024b0d469ae534b88e41";

export default node;
